<template>
  <div class="pb-5">
      <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Reports<span>
          <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / Leave & Attendance Reports</span>
      </h4>
      <p class="text-secondary pt-4">Review detailed leave and attendance records across your organization to ensure accurate tracking and policy compliance.</p>

      <div class="mt-4 reports-tab-nav">
        <div class="ibox-title dashboard_title company-form-box-title col-12">
          <h4 class="clearfix">
            <span class="float-left">Leave Reports
              <span class="title-sub-text">
              </span>
            </span>
            <span class="float-right"></span>
          </h4>
        </div>
      <div class="row">


        <div class="col-xs-12 col-md-4 d-flex">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Leave Report</h5>
              <p>This report shows detailed leave count of employees for each type of leave.</p>
              <b-button @click="$bvModal.show('bv-modal-leave-report')"> View Report</b-button>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 d-flex">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Compensatory Off Adjustment Report</h5>
              <p>This report displays detailed records of compensatory leaves, including the original worked days, the assigned off days, and the reasons.</p>
              <b-button @click="$bvModal.show('bv-modal-la-compensatory-leave-report')"> View Report</b-button>
          </div>
        </div>


        <div class="col-xs-12 col-md-4 d-flex">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Long Service Leave Report</h5>
              <p>This report shows detailed leave count of employees for each type of leave.</p>
              <b-button @click="$bvModal.show('bv-modal-long-service-leave-report')"> View Report</b-button>
          </div>
        </div>

      </div>

    </div>

    <div class="mt-4 reports-tab-nav">
        <div class="ibox-title dashboard_title company-form-box-title col-12">
          <h4 class="clearfix">
            <span class="float-left">Attendance Reports
              <span class="title-sub-text">
              </span>
            </span>
            <span class="float-right"></span>
          </h4>
        </div>
      <div class="row">

        <div class="col-xs-12 col-md-4 d-flex mb-4">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Daily Attendance</h5>
              <p>This report shows detailed daily attendance report of employees.</p>
              <b-button @click="$bvModal.show('bv-modal-la-daily-attendance-report')"> View Report</b-button>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 d-flex mb-4">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Department-wise Attendance Summary</h5>
              <p>This report shows detailed daily attendance report of employees.</p>
              <b-button @click="$bvModal.show('bv-modal-la-daily-summary-report')"> View Report</b-button>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 d-flex mb-4">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Attendance Summary</h5>
              <p>This report provides a summarized view of each employee’s attendance status for the selected date range, including total present days, absences, leaves, holidays, and weekends.</p>
              <b-button @click="$bvModal.show('bv-modal-la-monthly-attendance-summary')"> View Report</b-button>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 d-flex mb-4">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Attendance Report</h5>
              <p>This report displays a detailed breakdown of each employee's daily attendance status for the selected date range, showing presence, absence, leave categories, and holidays.</p>
              <b-button @click="$bvModal.show('bv-modal-la-monthly-attendance-report')"> View Report</b-button>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 d-flex mb-4">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>In/Out Report</h5>
              <p>This report shows the daily clock-in and clock-out times of employees for the selected date range, helping to track punctuality and work patterns.</p>
              <b-button @click="$bvModal.show('bv-modal-la-monthly-in-out-report')"> View Report</b-button>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 d-flex mb-4">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Working Hour Report</h5>
              <p>This report calculates the total working hours of each employee for the selected date range, including daily in/out durations and total hours worked.</p>
              <b-button @click="$bvModal.show('bv-modal-la-working-hour-report')"> View Report</b-button>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 d-flex">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Job Card</h5>
              <p>Job Cards for employees. Shows daily attendance details including in/out times, working hours, overtime, and a summary of total present, absent, leave and off days.</p>
              <b-button @click="$bvModal.show('bv-modal-la-job-card')"> View Report</b-button>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 d-flex">
          <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded w-100">
              <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
              <h5>Attendance Mobility Report</h5>
              <p>This report shows detailed attendance mobility logs for employees, including dates, check-in times, locations, and request statuses.</p>
              <b-button @click="$bvModal.show('bv-modal-la-attendance-mobility-report')"> View Report</b-button>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="bv-modal-leave-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Leave Report">
        <roster-leave-report > </roster-leave-report>
    </b-modal>

    <b-modal id="bv-modal-la-daily-attendance-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Daily Attendance Report">
      <roster-daily-report :flag="false"> </roster-daily-report>
    </b-modal>
    <b-modal id="bv-modal-long-service-leave-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Daily Attendance Report">
      <roster-long-service-leave-report :flag="false"> </roster-long-service-leave-report>
    </b-modal>
    <b-modal id="bv-modal-la-daily-summary-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Department-wise Attendance Summary">
      <roster-daily-summary-report> </roster-daily-summary-report>
    </b-modal>
    <b-modal id="bv-modal-la-monthly-attendance-summary" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Attendance Summary">
      <roster-monthly-summary :flag="1"> </roster-monthly-summary>
    </b-modal>
    <b-modal id="bv-modal-la-monthly-attendance-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Attendance Report">
      <roster-monthly-report :flag="2"> </roster-monthly-report>
    </b-modal>
    <b-modal id="bv-modal-la-monthly-in-out-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="In/Out Report">
      <roster-monthly-report :flag="3"> </roster-monthly-report>
    </b-modal>
    <b-modal id="bv-modal-la-working-hour-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Working Hour Report">
      <roster-monthly-report :flag="4"> </roster-monthly-report>
    </b-modal>
    <b-modal id="bv-modal-la-job-card" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Job Card">
      <roster-job-card> </roster-job-card>
    </b-modal>
    <b-modal id="bv-modal-la-compensatory-leave-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Compensatory Leave Report">
      <roster-compensatory-leave-report> </roster-compensatory-leave-report>
    </b-modal>
    <b-modal id="bv-modal-la-attendance-mobility-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Attendance Mobility Report">
      <roster-attendance-mobility-report> </roster-attendance-mobility-report>
    </b-modal>
    <div>

    </div>
  </div>
</template>
<script>
export default{
}
</script>
